import './style.scss';
import { useLocationName } from './hooks';

export const Location = () => {
  const { name, subDescription } = useLocationName();

  return (
    <div className="location">
      <div className="location_label">{name}</div>
      {subDescription && (
        <div className="location_subDescription">{subDescription}</div>
      )}
    </div>
  );
};
